import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-market-study-decorative',
  templateUrl: './market-study-decorative.component.html',
  styleUrls: ['./market-study-decorative.component.css']
})
export class MarketStudyDecorativeComponent implements OnInit {

  output: any = [];
  isLoader = false;
  body = true;
  space = " ";

  // optional dropdown list (kept for UI consistency, but decorative is locked)
  industry_type = [
    { "name": "Wood" },
    { "name": "Automotive" },
    { "name": "Industrial" },
    { "name": "Building Materials" }
  ];

  // decorative is locked as default
  search_filter = {
    created_by_id: "",
    customer_name: "",
    // customer_type: "",
    industry_type: "Decorative Coatings",
    marketing_country_id: "",
    marketing_state_id: "",
    marketing_area_id: "",
  };

  country_drop: any;
  statedrop: any;
  areadrop: any;

  constructor(private service: ServiceService) {}

  ngOnInit(): void {
    this.searchListing();
    this.dropdowncall();
  }

  // Excel Export
  excelExport() {
    var orderTable = document.getElementById('MarketStudy');
    var wb = XLSX.utils.table_to_book(orderTable, { sheet: "sheet1" });
    return XLSX.writeFile(wb, ('Decorative Market Study Report.xlsx'));
  }

  // Always filter with Decorative Coatings
  searchListing() {
    const search_string = `?industry_type=Decorative Coatings&marketing_country_id=${this.search_filter.marketing_country_id}&marketing_state_id=${this.search_filter.marketing_state_id}&marketing_area_id=${this.search_filter.marketing_area_id}&customer_name=${this.search_filter.customer_name}`;

    this.isLoader = true;
    this.service.viewMarketStudy(search_string).subscribe((res) => {
      console.log("API Responseee:", res);  // Inspect the API response
      this.output = res.data;
      console.log("Decorative data=", this.output);
      console.log("res=", res);
      this.isLoader = false;
    }, err => {
      console.error('Error fetching Decorative data', err);
      this.isLoader = false;
    });
  }

  countrySelected() {
    this.statedrop = [];
    this.search_filter.marketing_state_id = "";
    if (this.search_filter.marketing_country_id == null) {
      this.search_filter.marketing_country_id = "";
    }
    this.searchListing();
    this.stateDropdown();
  }

  stateSelected() {
    this.areadrop = [];
    this.search_filter.marketing_area_id = "";
    if (this.search_filter.marketing_state_id == null) {
      this.search_filter.marketing_state_id = "";
    }
    this.searchListing();
    this.AreaDropdown();
  }

  areaSelected() {
    if (this.search_filter.marketing_area_id == null) {
      this.search_filter.marketing_area_id = "";
    }
    this.searchListing();
  }

  customerSelected() {
    this.searchListing();
  }

  dropdowncall() {
    this.service.viewMarketCountry().subscribe((res) => {
      this.country_drop = res.data;
    });
  }

  stateDropdown() {
    var id = this.search_filter.marketing_country_id;
    this.service.viewMarketState(id).subscribe((res) => {
      this.statedrop = res.data;
    });
  }

  AreaDropdown() {
    var id = this.search_filter.marketing_state_id;
    this.service.viewMarketArea(id).subscribe((res) => {
      this.areadrop = res.data;
    });
  }

  hasProperty(property: string): boolean {
    return this.output.some((employee: any) => !!employee[property]);
  }
}
